// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.terms-of-use-pdf-viewer[data-v-e03dd104] {
  display: flex;
  flex-direction: column;
  width: 100%;
  font-family: "Poppins", sans-serif;
  color: #495057;
}
.terms-of-use-pdf-viewer--fullscreen[data-v-e03dd104] {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1055;
  background: #fff;
  padding: 20px;
}
.terms-of-use-pdf-viewer--fullscreen .terms-of-use-pdf-viewer__document[data-v-e03dd104] {
  flex: 1;
  min-height: 0;
  max-height: none;
}
.terms-of-use-pdf-viewer__toolbar[data-v-e03dd104] {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 12px;
  padding: 12px 16px;
  background: #f5f5f5;
  border: 1px solid #e0e0e0;
  border-radius: 8px 8px 0 0;
}
.terms-of-use-pdf-viewer__nav-group[data-v-e03dd104], .terms-of-use-pdf-viewer__zoom-group[data-v-e03dd104] {
  display: flex;
  align-items: center;
  gap: 8px;
}
.terms-of-use-pdf-viewer__nav-label[data-v-e03dd104] {
  font-size: 14px;
}
.terms-of-use-pdf-viewer__page-select[data-v-e03dd104] {
  width: 130px;
  font-family: inherit;
}
.terms-of-use-pdf-viewer__page-select[data-v-e03dd104]:focus {
  border-color: rgba(74, 127, 52, 0.35);
  box-shadow: 0 0 0 0.2rem rgba(74, 127, 52, 0.35);
}
.terms-of-use-pdf-viewer__zoom-level[data-v-e03dd104] {
  min-width: 50px;
  text-align: center;
  font-size: 14px;
}
.terms-of-use-pdf-viewer__fullscreen-btn[data-v-e03dd104] {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  padding: 0;
  background: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  color: #495057;
  font-size: 20px;
}
.terms-of-use-pdf-viewer__fullscreen-btn[data-v-e03dd104]:hover {
  background: #fafafa;
}
.terms-of-use-pdf-viewer__fullscreen-btn[data-v-e03dd104]:focus, .terms-of-use-pdf-viewer__fullscreen-btn.focus[data-v-e03dd104] {
  outline: 0;
  box-shadow: none;
}
.terms-of-use-pdf-viewer__document[data-v-e03dd104] {
  position: relative;
  width: 100%;
  max-height: min(450px, 100vh - 330px);
  min-height: 180px;
  padding: 16px;
  overflow-y: scroll;
  overflow-x: auto;
  background: #f5f5f5;
  border: 1px solid #e0e0e0;
  border-top: none;
  border-radius: 0 0 8px 8px;
}
.terms-of-use-pdf-viewer__page[data-v-e03dd104] {
  position: relative;
  box-sizing: content-box;
  margin: 0 auto 16px;
  background: #fff;
  border: 2px solid transparent;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
}
.terms-of-use-pdf-viewer__page--current[data-v-e03dd104] {
  border-color: rgba(74, 127, 52, 0.35);
}
.terms-of-use-pdf-viewer__page[data-v-e03dd104]:last-child {
  margin-bottom: 0;
}
.terms-of-use-pdf-viewer__canvas[data-v-e03dd104] {
  display: block;
  width: 100%;
  height: 100%;
}
.terms-of-use-pdf-viewer__error[data-v-e03dd104] {
  color: #a94442;
  text-align: center;
  padding: 20px;
}
@media (max-width: 575.98px) {
.terms-of-use-pdf-viewer--fullscreen[data-v-e03dd104] {
    padding: 8px;
}
.terms-of-use-pdf-viewer__toolbar[data-v-e03dd104] {
    gap: 8px;
    padding: 8px 12px;
}
.terms-of-use-pdf-viewer__nav-label[data-v-e03dd104] {
    display: none;
}
.terms-of-use-pdf-viewer__page-select[data-v-e03dd104] {
    width: 100px;
}
.terms-of-use-pdf-viewer__zoom-level[data-v-e03dd104] {
    min-width: 44px;
}
.terms-of-use-pdf-viewer__document[data-v-e03dd104] {
    max-height: min(450px, 100vh - 360px);
    padding: 12px;
}
.terms-of-use-pdf-viewer__page[data-v-e03dd104] {
    margin-bottom: 12px;
}
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
